module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9f8.f248b9a9.svg";